var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('div',{staticClass:"container"},[_c('router-view'),_c('vue-ins-progress-bar')],1),_c('CookieAcceptance')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }